import { ChangeDetectorRef, Component, Renderer2 } from '@angular/core';
import { FeatureFlagService } from '../../shared/services/feature-flag.service';
import { GlobalsService } from '../../shared/services/globals.service';
import { Subscription } from 'rxjs';
import { BaseGridEditLineComponent } from '../../shared/base-components/base-grid-editline.component';
import { DistributedPrintingService } from '../../shared/services/distributed-printing.service';
import { ZebraPrinterStatusDto } from '../../shared/models/ZebraPrinterStatusDto';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { SaveMode } from '../../shared/enums/SaveMode';
import { saveAs } from '@progress/kendo-file-saver';
import { CompositeFilterDescriptor, filterBy, FilterDescriptor } from "@progress/kendo-data-query";

@Component({
    selector: 'cp-zebra-printer-config',
    templateUrl: './zebra-printer-config.component.html',
    styleUrls: ['./zebra-printer-config.component.scss']
})
export class ZebraPrinterConfigComponent extends BaseGridEditLineComponent<ZebraPrinterStatusDto, null, DistributedPrintingService> {

    constructor(svc_data: DistributedPrintingService, renderer: Renderer2, cd: ChangeDetectorRef, globals: GlobalsService, featureFlagService: FeatureFlagService,) {
        super(globals, renderer, cd, featureFlagService);
        this.svc_data = svc_data;

        this.className = "ZebraPrinterStatusDto";
        this.appCode = "PrinterStatuses";
        this.appName = "Printer Statuses";
        this.disableCpSearchDialog();
    }
    subs_data: Subscription;
    subs_save: Subscription;
    dataLoading: boolean = false;
    saving: boolean = false;
    data: ZebraPrinterStatusDto[];
    filteredData: ZebraPrinterStatusDto[];
    searchText: string = '';
    openWindow: boolean = false;
    howToGuideToggle: boolean = false;
    windowTitle: string = '';
    showOnlyActive: boolean = false;
    printerQueueToggle: boolean = false;
    //gridData: ZebraPrinterStatusDto[];

    override ngOnInit() {
        super.ngOnInit();
        this.saveMode = SaveMode.all;
        this.canEdit = true;
        this.readOnly = false;
        this.getData();
    }

    createForm() {
        this.editForm = new UntypedFormGroup({
            'zebraPrinterId': new UntypedFormControl(),
            'printerDisplayName': new UntypedFormControl(),
            'printerDesc': new UntypedFormControl(),
            'printerSerialNbr': new UntypedFormControl(),
            'lastOnlineDt': new UntypedFormControl(),
            'isEnabled': new UntypedFormControl(),

        });
    }
    setForm() {
        this.editForm.patchValue({
            zebraPrinterId: this.selectedData.zebraPrinterId,
            printerDisplayName: this.selectedData.printerDisplayName,
            printerDesc: this.selectedData.printerDesc,
            printerSerialNbr: this.selectedData.printerSerialNbr,
            lastOnlineDt: this.selectedData.lastOnlineDt,
            isEnabled: this.selectedData.isEnabled
        });
    }
    protected getChangedObject(dataObj: ZebraPrinterStatusDto) {
        let busObj: ZebraPrinterStatusDto = new ZebraPrinterStatusDto(dataObj);
        return busObj;
    }
    customCheckBoxChanged(e: any, dataItem, rowIndex, column, columnIndex) {
        if (column.field === "isEnabled") {
            this.editForm.patchValue({
                isEnabled: e.target.checked
            });

        }
    }

    getData(): void {
        this.saving = true;

        this.dataLoading = true;
        this.subs_data = this.svc_data.getPrinterStatuses(false).subscribe(data => {
            if (data && data.success) {
                let arr: ZebraPrinterStatusDto[] = [];
                for (let i = 0; i < data.resultList.length; i++) {
                    arr.push(new ZebraPrinterStatusDto(data.resultList[i]));
                }
                this.data = arr;
                this.gridData = this.data;
                this.dataLoading = false;
                this.saving = false;
            } else if(!data.success) {
                this.dataLoading = false;
                this.saving = false;
            }
            this.convertStatusString();

            this.saving = false;
        });
    }

    convertStatusString() {
        this.gridData?.forEach((item, i) => {
            if (item.printerErrorStates != null && item.printerErrorStates.length >= 1) {
                let cleanedString = item.printerErrorStates.replace(/[\[\]"]/g, '');
                let combinedString = cleanedString.replace(/\s/g, '');
                let errorFormat = cleanedString.split(",");
                this.gridData[i].printerErrorStates = errorFormat
            }
        })
    }

    save() {
        this.gridData?.forEach(item => {
            if (item.isUpdated) {
                this.subs_save = this.svc_data.updatePrinterStatus(item).subscribe(data => {
                    if (data && data.success) {
                        let item = new ZebraPrinterStatusDto(data.result);
                        this.saveSuccess(item);
                        this.getData();
                    } else {
                        this.saveError(item, "Failed to Update Printer");
                        this.getData();
                    }
                },
                    err => { this.saveError(item, "Failed to Update Printer"); }
                );
            }
        });
    }

    getAgentDownload() {
        this.notify("Download Started", "S", false);
        this.svc_data.getAgentDownload().subscribe(data => {
            saveAs(data, "CP Distributed Printer Install.msi");

        });
    }

    showOnlyActivePrinters() {
        this.showOnlyActive = !this.showOnlyActive;
        this.createFilter();
    }
    GridFilter: CompositeFilterDescriptor = { filters: [], logic: "and" };
    onlyActiveFilter: FilterDescriptor = { field: "isEnabled", operator: "eq", value: true };
    createFilter() {
        this.originalData = this.gridData;

        if ( this.showOnlyActive ) {
            this.GridFilter.filters = [ this.onlyActiveFilter ];
            this.gridData = filterBy( this.gridData, this.GridFilter );
        } else {
            this.GridFilter.filters = [];
            this.gridData = this.originalData;
        }
    }

    searchValueChange( searchValue ): void {
        console.log('searchValue', searchValue);
        //TODO: Add search param to api call
        //this.searchText.length > 2 ? this.getCycleCountingData( this.searchText, false ) : this.getCycleCountingData( '0', false );
    }

    //download(data: any) {
    //    let busObj: VehicleDocumentBus = new VehicleDocumentBus(data);
    //    this.dataLoading = true;
    //    this.svc_data.getDocument(busObj.vehicleDocumentId, 'VEHDOC').subscribe((info: BaseMessageInfo) => {
    //        this.dataLoading = false;
    //        this.document = new CDocument(info.primaryReturn);
    //        this.dataLoading = false;
        //        if (this.document.hasDocumentB64String) {
    //            let downloadData = "data:" + this.document.mimeType + ";base64," + this.document.documentB64String;
    //            saveAs(downloadData, this.document.fileName);
    //        }
    //        else {
    //            this.sendParentMessage(MessageType.msgPopup, "Missing Data", "No Attachment Data Found");
    //        }
    //        //window.open(this.document);
    //    });
    //}

    showHowToGuide() {
        this.printerQueueToggle = false;
        this.howToGuideToggle = !this.howToGuideToggle;
        this.openWindow = !this.openWindow;
        this.windowTitle = this.howToGuideToggle ? 'How To Install Zebra Printer' : '';
    }

    showPrinterQueue(event) {
        console.log('event', event);
        this.howToGuideToggle = false;
        this.printerQueueToggle = !this.printerQueueToggle;
        this.openWindow = !this.openWindow;
        this.windowTitle = 'Printer Queue for ';
    }
}
